import { Component, useEffect, type ReactNode } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { entry, router } from '@/routes';

declare global {
  var __onautoRouteInventory:
    | {
        routes: Array<{
          pattern: string;
          path: string;
          title: string;
          page: string;
          standalone: boolean;
          isPublic: boolean;
        }>;
        entry: typeof entry;
      }
    | undefined;
}

class AppBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    return this.state.failed ? (
      <main className="grid min-h-screen place-items-center p-6">
        <p className="rounded-xl border bg-card p-6">Seattle Bus Times could not load. Please refresh and try again.</p>
      </main>
    ) : (
      this.props.children
    );
  }
}
function AppRuntime() {
  useEffect(() => {
    document.getElementById('root')?.setAttribute('data-app-ready', '1');
    const routes = Object.values(router.routesById)
      .filter((route) => route.id !== '__root__')
      .map((route) => {
        const data = route.options.staticData as {
          title: string;
          page: string;
          standalone: boolean;
          isPublic: boolean;
        };
        return {
          pattern: route.fullPath.replace(/\$([^/]+)/g, '[$1]'),
          path: route.fullPath,
          title: data.title,
          page: data.page,
          standalone: data.standalone,
          isPublic: data.isPublic,
        };
      });
    globalThis.__onautoRouteInventory = { routes, entry };
  }, []);
  return <RouterProvider router={router} />;
}
export function App() {
  return (
    <AppBoundary>
      <AppRuntime />
    </AppBoundary>
  );
}
